import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography, } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { setOriginalParams } from '../../../../../features/mapsSlice';
import { useDispatch } from 'react-redux';

interface MapDuplicateModalProps {
  open: boolean;
  handleClose: () => void;
}

const DuplicateMapModal = ({ open, handleClose }: MapDuplicateModalProps) => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleDuplicateMap = () => {
    const currentParams = searchParams.toString();
    dispatch(setOriginalParams(currentParams));
    navigate(`/data_collection/unifier/duplicate_map/`);
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle>Duplicate Map</DialogTitle>
        <DialogContent>
          <Typography>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 2, pb: 2 }}>
          <Button onClick={handleClose} color="secondary">
            No
          </Button>
          <Button color="secondary" variant="contained" onClick={() => handleDuplicateMap()}>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DuplicateMapModal;
